import React from 'react'
import CustomSelect from 'src/components/CustomComponents/CustomSelect'
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect'

export const BOOK_LANGUAGE_OPTIONS = [
	{ label: 'English - English', value: 'en-en' },
	{ label: 'English - Vietnamese', value: 'en-vi' },
	{ label: 'English - Chinese', value: 'en-zh' },
	{ label: 'English - Japanese', value: 'en-ja' },
	{ label: 'English - Korean', value: 'en-ko' },
	{ label: 'English - German', value: 'en-de' },
	{ label: 'English - French', value: 'en-fr' },
	{ label: 'English - Spanish', value: 'en-es' },
	{ label: 'English - Arabic', value: 'en-ar' },
	{ label: 'English - Russian', value: 'en-ru' },
	{ label: 'English - Italian', value: 'en-it' },
	{ label: 'English - Portuguese', value: 'en-pt' },
	{ label: 'English - Thai', value: 'en-th' },
	{ label: 'English - Indonesian', value: 'en-id' },
	{ label: 'English - Hindi', value: 'en-hi' },
]

const ALL_LANGUAGES_VALUE = '__all_languages__'

const BOOK_LANGUAGE_MULTI_OPTIONS_WITH_ALL = [
	{ label: 'All', value: ALL_LANGUAGES_VALUE },
	...BOOK_LANGUAGE_OPTIONS,
]

const BOOK_LANGUAGE_OPTIONS_WITH_ALL = [
	{ label: 'All', value: null },
	...BOOK_LANGUAGE_OPTIONS,
]

interface BookLanguageProps {
	multiple?: boolean
	includeAll?: boolean
	value: string | null | string[]
	onChange: ((value: string | null) => void) | ((value: string[]) => void)
	sx?: any
	placeholder?: string
	disabled?: boolean
}

function BookLanguage({
	multiple = false,
	includeAll = false,
	value,
	onChange,
	disabled,
	sx,
	placeholder = 'Language',
}: BookLanguageProps) {
	if (multiple) {
		const handleChangeMultiple = (nextValues: string[]) => {
			if (includeAll && nextValues.includes(ALL_LANGUAGES_VALUE)) {
				const allLanguageValues = BOOK_LANGUAGE_OPTIONS.map((item) => item.value)
				;(onChange as (value: string[]) => void)(allLanguageValues)
				return
			}

			;(onChange as (value: string[]) => void)(
				nextValues.filter((item) => item !== ALL_LANGUAGES_VALUE),
			)
		}

		return (
			<CustomMultiSelect
				value={Array.isArray(value) ? value : []}
				data={
					includeAll
						? BOOK_LANGUAGE_MULTI_OPTIONS_WITH_ALL
						: BOOK_LANGUAGE_OPTIONS
				}
				disabled
				onChange={handleChangeMultiple}
				placeholder={placeholder}
				sx={sx}
			/>
		)
	}

	return (
		<CustomSelect
			value={!Array.isArray(value) ? value : null}
			data={includeAll ? BOOK_LANGUAGE_OPTIONS_WITH_ALL : BOOK_LANGUAGE_OPTIONS}
			onChange={onChange as (value: string | null) => void}
			placeholder={placeholder}
			sx={sx}
		/>
	)
}

export default React.memo(BookLanguage)
